module.exports = __webpack_public_path__ + "assets/img/img-content-none02.8bc3c3ca.png";